"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.modalActions = exports.ModalReducerUI = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.link-over-box-container"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.link-over-box"));

var _gerenciatdReact3 = _interopRequireDefault(require("@bit/gerenciatd.react.icon-library"));

var _gerenciatdReact4 = _interopRequireDefault(require("@bit/gerenciatd.react.icon"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.html-utils");

var _gerenciatdReact5 = _interopRequireWildcard(require("@bit/gerenciatd.react.button"));

var _ModalReducer = _interopRequireWildcard(require("./ModalReducer"));

require("./Modal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ModalReducerUI = _ModalReducer["default"];
exports.ModalReducerUI = ModalReducerUI;
var modalActions = _ModalReducer.actions;
exports.modalActions = modalActions;
var ANIMATION_MODAL_IN = 'fadeIn animatedModal1';
var ANIMATION_MODAL_OUT = 'fadeOut animatedModal1';
/* This indicates in which div, modal is going to be placed <div id="modal-root"></div> */

var modalRoot = document.getElementById('modal-root-spa');
/**
 * Statefull component to a Modal. Version: 0.0.4
 * @param {string} idModal id what indentify this modal
 * @param {string} kind version/step/kind usefull for css versions.
 * if this idModal and his kind are defined on setupBasics,this properties will be injected
 * @param {string} buttonDynamicLabel button label for non static modals
 * @param {func} onClose Function to reset variables
 * @param {JSX} children Children for modal
 * 1) if there are children those will be rendered.
 * 2) if u have children and dont have setupbasics properties,
 *    make sure u can close your modal on mobile version
 * @returns {JSX} Component JSX.
 * For handling use: setModalVisibility on reducers/ui from your parent component
 */

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      var _this$state = _this.state,
          animationListener = _this$state.animationListener,
          mounted = _this$state.mounted;

      if (!animationListener && mounted) {
        // document.body.classList.add('modal-open');
        var transitionEvent = (0, _gerenciatdUtils.whichAnimationEvent)();
        var element = document.getElementById('animationReference');

        if (transitionEvent) {
          element.addEventListener(transitionEvent, function () {
            _this.unMount();
          });

          _this.setState({
            animationListener: true
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setMyVisibility", function () {
      var _this$props = _this.props,
          idModalVisible = _this$props.idModalVisible,
          idModal = _this$props.idModal,
          onClose = _this$props.onClose;

      if (!idModalVisible) {
        // Si es null se activa la modal
        _this.props.setModalVisibility(idModal);
      } else if (idModal === idModalVisible) {
        // Si la modal activa es la misma que la mia, la cierro
        _this.props.setModalVisibility(null);

        if (onClose) {
          onClose();
        }

        if (_this.props.buttonProps && _this.props.buttonProps.onClick) {
          _this.props.buttonProps.onClick();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "mainButtonClicked", function () {
      var _this$props2 = _this.props,
          mainButton = _this$props2.mainButton,
          canBeClosed = _this$props2.canBeClosed;

      if (mainButton.handleClick) {
        mainButton.handleClick();
      }

      if (canBeClosed) {
        _this.setMyVisibility();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "secondaryButtonClicked", function () {
      var _this$props3 = _this.props,
          secondaryButton = _this$props3.secondaryButton,
          canBeClosed = _this$props3.canBeClosed;

      if (secondaryButton.handleClick) {
        secondaryButton.handleClick();
      }

      if (canBeClosed) {
        _this.setMyVisibility();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "unMount", function () {
      var _this$state2 = _this.state,
          animation = _this$state2.animation,
          mounted = _this$state2.mounted;

      if (animation === ANIMATION_MODAL_OUT && mounted) {
        _this.setState({
          mounted: false,
          animationListener: false
        }); // document.body.classList.remove('modal-open');

      }
    });

    var _idModal = props.idModal,
        _idModalVisible = props.idModalVisible;
    _this.state = {
      idModal: _idModal,
      mounted: _idModalVisible && _idModalVisible === _idModal,
      animation: ANIMATION_MODAL_IN,
      animationListener: null
    };
    return _this;
  }
  /* For handle animation */


  _createClass(Modal, [{
    key: "render",

    /* FUNCTIONS FOR KINDS ON SETUPS BASICS ENDS */
    value: function render() {
      /* From state */
      var mounted = this.state.mounted;

      if (mounted) {
        var _this$state3 = this.state,
            idModal = _this$state3.idModal,
            animation = _this$state3.animation;
        var _this$props4 = this.props,
            kind = _this$props4.kind,
            defaultClosebehaviour = _this$props4.defaultClosebehaviour,
            title = _this$props4.title,
            mainButton = _this$props4.mainButton,
            secondaryButton = _this$props4.secondaryButton,
            linksArray = _this$props4.linksArray,
            canBeClosed = _this$props4.canBeClosed;
        var closeDefaultClick = this.setMyVisibility;

        if (!defaultClosebehaviour || kind === 'fetching') {
          closeDefaultClick = null;
        }
        /* Check if we have info for this kind */


        return _reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
          store: this.props.store
        }, /*#__PURE__*/_react["default"].createElement("div", {
          idmodal: idModal,
          id: idModal,
          className: "modalContainer",
          onTransitionEnd: this.transitionEnd
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "opacityLayout ".concat(animation),
          onClick: closeDefaultClick,
          role: "button",
          tabIndex: "0",
          onKeyPress: closeDefaultClick
        }), /*#__PURE__*/_react["default"].createElement("div", {
          id: "animationReference",
          className: "modal ".concat(kind, " ").concat(animation)
        }, canBeClosed && /*#__PURE__*/_react["default"].createElement("span", {
          className: "xClose"
        }, /*#__PURE__*/_react["default"].createElement(_gerenciatdReact4["default"], {
          classIcon: _gerenciatdReact3["default"].x,
          onClick: this.setMyVisibility
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "title"
        }, /*#__PURE__*/_react["default"].createElement("h2", null, title)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "content"
        }, this.props.children && /*#__PURE__*/_react["default"].createElement("div", {
          className: "ownContent"
        }, this.props.children)), mainButton && /*#__PURE__*/_react["default"].createElement("div", {
          className: "buttonsBar"
        }, /*#__PURE__*/_react["default"].createElement(_gerenciatdReact5["default"], _extends({
          theme: _gerenciatdReact5.buttonThemes.BLUE,
          type: _gerenciatdReact5.buttonTypes.SOLID,
          onClick: this.mainButtonClicked,
          buttonType: "reset"
        }, mainButton, {
          wrapperClass: "mainButton modalButton"
        })), secondaryButton && /*#__PURE__*/_react["default"].createElement(_gerenciatdReact5["default"], _extends({
          theme: _gerenciatdReact5.buttonThemes.BLUE,
          type: _gerenciatdReact5.buttonTypes.SOFT,
          onClick: this.secondaryButtonClicked,
          buttonType: "reset"
        }, secondaryButton, {
          wrapperClass: "secondaryButton modalButton"
        }))), linksArray && /*#__PURE__*/_react["default"].createElement("div", {
          className: "linksBar"
        }, linksArray.map(function (linkObj, index) {
          return /*#__PURE__*/_react["default"].createElement(_gerenciatdReact["default"], null, /*#__PURE__*/_react["default"].createElement(_gerenciatdReact2["default"], {
            alt: linkObj.alt,
            link: linkObj.link
          }, linkObj.text));
        }))))), modalRoot);
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var idModalVisible = props.idModalVisible,
          idModal = props.idModal;
      var newMountedValue = idModalVisible && idModalVisible === idModal;

      if (!newMountedValue) {
        return _objectSpread({}, state, {
          animation: ANIMATION_MODAL_OUT
        });
      }

      return _objectSpread({}, state, {
        animation: ANIMATION_MODAL_IN,
        mounted: newMountedValue
      });
    }
    /* Adding animation listener */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  idModalVisible: _propTypes["default"].string,
  defaultClosebehaviour: _propTypes["default"].bool,
  buttonProps: _propTypes["default"].object,
  titleBar: _propTypes["default"].object,
  canBeClosed: _propTypes["default"].bool
};
Modal.defaultProps = {
  idModalVisible: null,
  defaultClosebehaviour: true,
  buttonProps: null,
  titleBar: null,
  canBeClosed: true
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setModalVisibility: function setModalVisibility(idModal) {
      return dispatch(_ModalReducer.actions.setModalVisibility(idModal));
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    idModalVisible: state.modal.idModalVisible
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Modal);

exports["default"] = _default;

//# sourceMappingURL=index.js.map